import script from "./overview.vue?vue&type=script&setup=true&name=Company&lang=js"
export * from "./overview.vue?vue&type=script&setup=true&name=Company&lang=js"

import "./overview.vue?vue&type=style&index=0&id=74e30d39&lang=less&scoped=true"

import exportComponent from "/Users/liuxiong/Documents/美通官网/huanshuntong/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e30d39"]])

export default __exports__